import React, {useState, useEffect, useRef, useCallback} from 'react';
import OrgChart from '../../Common/Balkan/orgchart';
import styled, {ThemeProvider} from 'styled-components';
import theme from '@ey/styled-theme';
import ReactDOM from 'react-dom';
import {IconoirNavArrowDown, IconoirNavArrowUp} from '@ey-xd/motif-icon';
import {labels} from '../../../util/utils';

import {maxNodeAllowedAtAnyLevel} from '../../../util/uiconstants';
import Button from '../../CoreWrappers/Button';
import {orgStructureSelector} from './Helper/dataSelector';
import RemoveAdminsTooltip from './RemoveAdminsTooltip';
import EntityModal from './EntityModal';
import _ from 'lodash';
import LevelLegends from './LevelLegend';
import {stringFormat} from '@ey/utils';
import {charts} from 'highcharts';
import {Buffer} from 'buffer';

const Step2OrgChart = (props) => {
	const {nodes, setNodes} = props;
	let orgStructure = orgStructureSelector();
	const [showModal, setShowModal] = useState(false);
	const [selectedNode, setSelectedNode] = useState(null);
	const [existingDomains, setExistingDomains] = useState([]);

	useEffect(() => {
		if (_.size(nodes) > 0) {
			let domains = [];
			_.forEach(nodes, (node) => {
				_.size(node.domains) > 0 && domains.push(...node.domains);
			});
			setExistingDomains([...new Set(domains)]);
		}
	}, [nodes]);

	// Recursive function to get all childs for given nodes. It is use to delete all child elements on deletion of node.
	// 3 inputs.. sender is the chart data, node is the node which is removed, nodeIdsToRemove will have list of nodes that will be deleted.
	const getNodesForDeletion = (sender, node, nodeIdsToRemove) => {
		nodeIdsToRemove.push(node.id);
		for (var i = 0; i < node.childrenIds.length; i++) {
			getNodesForDeletion(sender, sender.getNode(node.childrenIds[i]), nodeIdsToRemove);
		}
	};

	let divRef = useRef(null);
	let addCalled = useRef(0);
	let chart;

	const handleExpandClick = () => {
		chart.draw(OrgChart.action.init);
		chart.expand(null, 'all', chart.center(1, {horizontal: false, vertical: true}));
	};

	const handleCollapseClick = () => {
		var ids = chart.getNode('1').childrenIds;
		chart.collapse(1, ids);
	};

	const getNewMaxLevel = (draggedNode, maxLevel) => {
		let prevBranchMaxLength = maxLevel;
		draggedNode.children.forEach((child) => {
			let newMaxLevel = maxLevel + 1;
			if (child.children.length > 0) {
				prevBranchMaxLength = getNewMaxLevel(child, newMaxLevel);
			} else {
				if (newMaxLevel > prevBranchMaxLength) {
					prevBranchMaxLength = newMaxLevel;
				}
			}
		});
		return prevBranchMaxLength;
	};

	// Below method will give number of nodes present at given level.
	const getNodeCountAtGivenLevel = (sender, level) => {
		let nodesAtCurrentLevel = 0;
		Object.keys(sender.nodes).map((key) => {
			if (sender.nodes[key].level == level) {
				nodesAtCurrentLevel = nodesAtCurrentLevel + 1;
			}
		});
		return nodesAtCurrentLevel;
	};

	// Below method will apply given tags to all the nodes at given level.
	const updateTagAtGivenLevel = (sender, level, tagToBeApplied) => {
		let levelItems = [];
		Object.keys(sender.nodes).map((key) => {
			if (sender.nodes[key].level == level) {
				levelItems.push(sender.nodes[key].id);
			}
		});
		let itemsToBeUpdated = props.nodes.filter((node) => levelItems.includes(node.id));
		let itemsNotToBeUpdated = props.nodes.filter((node) => !levelItems.includes(node.id));
		itemsToBeUpdated.forEach((item) => (item.tags = tagToBeApplied));
		setNodes([...itemsNotToBeUpdated, ...itemsToBeUpdated]);
	};

	const saveEntityDetails = (id, entityName, selectedUsers, selectedDomains) => {
		let updatedNodes = nodes.map((x) => {
			if (x.id !== id) {
				return x;
			} else {
				let admins = _.sortBy(selectedUsers, 'firstName');
				let firstAdmin;
				if (admins.length > 0) {
					firstAdmin = `${admins[0].firstName} ${admins[0].lastName ? admins[0].lastName : ''}`;
				} else {
					firstAdmin = labels.adminsNoneLabel;
				}
				selectedDomains.sort();
				let firstDomain = selectedDomains.length > 0 ? selectedDomains[0] : labels.none;
				return {
					...x,
					entityName: entityName,
					admins: selectedUsers,
					adminsHeaderLabel: labels.adminsHeaderLabel,
					firstAdmin: firstAdmin,
					adminsMoreCountLabel: admins.length > 1 ? stringFormat(labels.moreCountLabel, admins.length - 1) : '',
					domains: selectedDomains,
					domainsHeaderLabel: labels.domainsHeaderLabel,
					firstDomain: firstDomain,
					domainsMoreCountLabel:
						selectedDomains.length > 1 ? stringFormat(labels.moreCountLabel, selectedDomains.length - 1) : '',
					isEdited: orgStructure.findIndex((o) => o.id == id) !== -1 ? true : false,
					addBtn: '1'
				};
			}
		});
		setNodes(updatedNodes);
	};

	function icons(data) {
		let iconsGroup = `<g transform="matrix(2,0,0,2,${
			_.isEmpty(data.tags) || data.tags?.includes('rootElement_maxNodeAddedAtNextLevel') ? 180 : 140
		},100)">`;

		// if (!data.tags?.includes('rootElement_maxNodeAddedAtNextLevel') && !data.tags?.includes('lastNodeElements') && !data.tags?.includes('middleElement_maxNodeAddedAtNextLevel')) {
		// 	iconsGroup += Buffer.from(
		// 		`<svg class="eng-icon add" version="1.1"  width="50px" height="50px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
		// 	 viewBox="0 0 92 92" enable-background="new 0 0 92 92" xml:space="preserve"><title>${labels.addLabel}</title><g transform="matrix(0.8,0,0,0.8,0,0)" class="svg-btn-add"` + ` data-id="${data.id}">` +
		// 			`<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"></path>
		// 		</g></svg>`
		// 	).toString('base64');
		// }

		// iconsGroup += Buffer.from(
		// 	`<svg class="eng-icon	edit" version="1.1" width="50px" height="50px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
		// viewBox="0 0 92 92" enable-background="new 0 0 92 92" xml:space="preserve"><title>${labels.editLabel}</title><g transform="matrix(0.8,0,0,0.8,35,0)" class="svg-btn-edit"` + ` data-id="${data.id}">
		// <path xmlns="http://www.w3.org/2000/svg" d="M0.5 25.5V6L20 1V25.5H0.6Z" stroke="black" stroke-opacity="0.01" fill-opacity="0.01"/>
		// <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"></path>
		// </g></svg>`
		// ).toString('base64');

		// if (!_.isEmpty(data.tags) && !data.tags?.includes('rootElement_maxNodeAddedAtNextLevel')) {
		// 	iconsGroup += Buffer.from(
		// 		`<svg class="eng-icon delete" version="1.1" width="50px" height="50px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
		// 	viewBox="0 0 92 92" enable-background="new 0 0 92 92" xml:space="preserve"><title>${labels.removeLabel}</title><g transform="matrix(0.8,0,0,0.8,70,0)" class="svg-btn-remove"` + `data-id="${data.id}">
		// 	<path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"></path>
		// 	</g></svg>`
		// 	).toString('base64');
		// }

		if (
			!data.tags?.includes('rootElement_maxNodeAddedAtNextLevel') &&
			!data.tags?.includes('lastNodeElements') &&
			!data.tags?.includes('middleElement_maxNodeAddedAtNextLevel')
		) {
			iconsGroup +=
				`<svg class="eng-icon add" version="1.1"  width="50px" height="50px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
			 viewBox="0 0 92 92" enable-background="new 0 0 92 92" xml:space="preserve"><title>${labels.addLabel}</title><g transform="matrix(0.8,0,0,0.8,0,0)" class="svg-btn-add"` +
				` data-id="${data.id}">` +
				`<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"></path>
				</g></svg>`;
		}

		iconsGroup +=
			`<svg class="eng-icon	edit" version="1.1" width="50px" height="50px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
		viewBox="0 0 92 92" enable-background="new 0 0 92 92" xml:space="preserve"><title>${labels.editLabel}</title><g transform="matrix(0.8,0,0,0.8,35,0)" class="svg-btn-edit"` +
			` data-id="${data.id}">
		<path xmlns="http://www.w3.org/2000/svg" d="M0.5 25.5V6L20 1V25.5H0.6Z" stroke="black" stroke-opacity="0.01" fill-opacity="0.01"/>
		<path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"></path>
		</g></svg>`;

		if (!_.isEmpty(data.tags) && !data.tags?.includes('rootElement_maxNodeAddedAtNextLevel')) {
			iconsGroup +=
				`<svg class="eng-icon delete" version="1.1" width="50px" height="50px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
			viewBox="0 0 92 92" enable-background="new 0 0 92 92" xml:space="preserve"><title>${labels.removeLabel}</title><g transform="matrix(0.8,0,0,0.8,70,0)" class="svg-btn-remove"` +
				`data-id="${data.id}">
			<path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"></path>
			</g></svg>`;
		}

		iconsGroup += '</g>';
		return iconsGroup;
	}

	function binder(sender, node) {
		var data = sender.get(node.id);
		var field = '<text style="font-size: 32px;" fill="#FF7F27" x="105" y="100" text-anchor="start"></text>';
		return field + icons(data);
	}

	function nodeStateUpdate(id) {
		// Once item is added to orgChart, exp field is not update for chart state.
		// This field contains nodes which are expanded. It should be updated once item is added.
		let currentChartState = JSON.parse(localStorage.getItem('StateStep2OrgChart'));
		currentChartState.exp = [...currentChartState.exp, id];
		localStorage.setItem('StateStep2OrgChart', JSON.stringify(currentChartState));
		return false;
	}

	function resetRef() {
		setTimeout(() => {
			addCalled.current = 0;
		}, 1000);
	}

	useEffect(() => {
		if (nodes.length > 0) {
			chart = new OrgChart(divRef.current, {
				mixedHierarchyNodesSeparation: 5,
				nodes: nodes.map((x) => {
					return {...x, escapedEntityName: _.escape(x.entityName), addBtn: x.id};
				}),
				template: 'entityTemplate',
				align: OrgChart.ORIENTATION,
				nodeMouseClick: OrgChart.action.none,
				enableDragDrop: true,
				enableSearch: false,
				editForm: null,
				mouseScrool: OrgChart.action.none,
				toolbar: {
					fullScreen: false,
					zoom: true,
					fit: false,
					expandAll: false
				},
				nodeBinding: {
					field_0: 'escapedEntityName',
					field_1: 'adminsHeaderLabel',
					field_2: 'firstAdmin',
					field_3: 'adminsMoreCountLabel',
					field_4: 'domainsHeaderLabel',
					field_5: 'firstDomain',
					field_6: 'domainsMoreCountLabel',
					field_7: binder
				},
				state: {
					name: 'StateStep2OrgChart',
					readFromLocalStorage: true,
					writeToLocalStorage: true
				},
				tags: {
					lastNodeElements: {
						template: 'entityTemplate'
					},
					middleNodeElements: {},
					rootElement_maxNodeAddedAtNextLevel: {},
					middleElement_maxNodeAddedAtNextLevel: {}
				}
			});

			// If edit request
			// Iterate thriugh nodes
			// If level 2/3 -> middleNodeElements
			// If level 4 -> lastNodeElements
			// For each level... get counts of elements. If it is 20... then update tags for each node at its parent level
			//	=> If parent level is 1 (root). Apply tag rootElement_maxNodeAddedAtNextLevel
			//	=> If parent level is not 1 (node other then root). Apply tag middleElement_maxNodeAddedAtNextLevel

			chart.editUI.on('field', function(sender, args) {
				if (
					args.name === 'escapedEntityName' ||
					args.name === 'engagements' ||
					args.name === 'engagementLabel' ||
					args.name === 'Add new field' ||
					args.name === 'isAssistant'
				) {
					return false;
				}
				if (args.name === 'entityName') {
					var lbl = args.field.querySelector('div');
					lbl.innerHTML = labels.entityName;
					var txt = args.field.querySelector('input');
					txt.maxLength = 100;
					if (txt.value === labels.enterEntityName) {
						txt.value = '';
						txt.placeholder = labels.enterEntityName;
					}
				}
			});

			const findElement = (id) => {
				var nodeElements = document.getElementsByClassName('node');
				var nodeElementsArray = Object.keys(nodeElements).map((key) => nodeElements[key]);
				let ele = false;
				if (!id) {
					return false;
				}
				nodeElementsArray.forEach((element) => {
					if (element.getAttribute('data-n-id') !== id) {
						element.classList.remove('active-node');
						return false;
					}
					ele = element;
				});
				return ele;
			};

			chart.editUI.on('show', function(sender, args) {
				let element = findElement(args);
				element?.classList.add('active-node');
				let nodeDetails = props.nodes.filter((node) => node.id === args);
				setSelectedNode(nodeDetails[0]);
				setShowModal(true);
			});

			chart.editUI.on('remove', function(sender, args) {
				let element = findElement(args);
				element?.classList.remove('active-node');
			});

			chart.editUI.on('cancel', function(sender, args) {
				findElement(args); // remove active node css
			});

			function removedNode(sender, nodeId, newPidsAndStpidsForIds) {
				let nodeIdsToRemove = [];
				let node = chart.getNode(nodeId);
				getNodesForDeletion(sender, node, nodeIdsToRemove);
				for (let i = 0; i < nodeIdsToRemove.length; i++) {
					sender.remove(nodeIdsToRemove[i]);
				}

				let updatedNodes = nodes.filter((n) => !nodeIdsToRemove.includes(n.id.toString()));
				setNodes(updatedNodes);
				return false;
			}

			chart.on('init', function(sender) {
				var plusBtn = document.querySelector('[data-tlbr="plus"]');
				var minusBtn = document.querySelector('[data-tlbr="minus"]');

				plusBtn?.setAttribute('title', labels.zoomIn);
				minusBtn?.setAttribute('title', labels.zoomOut);
			});

			chart.on('update', function(sender, oldNode, newNode) {
				if (newNode.entityName.trim() === '') {
					newNode.entityName = labels.enterEntityName;
				}
				let updatedNodes = nodes.map((x) => {
					if (x.id !== oldNode.id) {
						return x;
					} else {
						return {
							...x,
							entityName: newNode.entityName
						};
					}
				});
				setNodes(updatedNodes);
			});

			// On remove, ensure to remove child nodes also.
			chart.on('removed', function(sender, nodeId, newPidsAndStpidsForIds) {
				const nodesLeft = Object.keys(sender.nodes);
				let updatedNodes = nodes.filter((n) => nodesLeft.includes(n.id.toString()));
				setNodes(updatedNodes);
				sender.draw();
			});

			chart.on('drop', function(sender, draggedNodeId, droppedNodeId) {
				let draggedNode = sender.config.nodes.filter((n) => n.id === draggedNodeId)[0];
				let droppedNode = sender.getNode(droppedNodeId);

				if (droppedNode) {
					if (
						droppedNode.pid === draggedNodeId ||
						sender.getNode(droppedNode.pid)?.pid === draggedNodeId ||
						sender.getNode(sender.getNode(droppedNode.pid)?.pid)?.pid === draggedNodeId
					) {
						return false;
					}
					var newMaxLevel = getNewMaxLevel(sender.getNode(draggedNodeId), droppedNode.level + 1);
					if (newMaxLevel > 3) {
						return false;
					}

					let droppedNodeLevel = droppedNode.level;

					// If element is dragged and drop, update tags props for applicable menu option
					if (droppedNodeLevel === 2) {
						draggedNode.tags = ['lastNodeElements'];
					} else {
						draggedNode.tags = ['middleNodeElements'];
					}
					draggedNode.pid = droppedNodeId;
					sender.update(draggedNode);

					sender.draw();

					setTimeout(function() {
						// If element is dragged and drop, update tags props for applicable menu option
						// To do - only do this for children of dragged nodes instead of all nodes
						sender.config.nodes.forEach((n) => {
							let newNodeLevel = sender.getNode(n.id).level;
							if (newNodeLevel === 3) {
								n.tags = ['lastNodeElements'];
								sender.update(n);
							} else {
								if (newNodeLevel !== 0) {
									n.tags = ['middleNodeElements'];
									sender.update(n);
								}
							}

							return;
						});
						sender.draw();
					}, 1000);

					let newNodes = [...nodes];
					newNodes.forEach((n) => {
						let newNodeLevel = chart.getNode(n.id).level;
						if (newNodeLevel === 3) {
							n.tags = ['lastNodeElements'];
						} else {
							if (newNodeLevel !== 0) {
								n.tags = ['middleNodeElements'];
							}
						}
						if (n.id === draggedNode.id) {
							n.pid = droppedNode.id;
						}
					});
					setNodes(newNodes);
				}
			});
			chart.on('redraw', function(sender) {
				var adminsBtns = document.querySelectorAll('.svg-btn-admins');
				var domainsBtns = document.querySelectorAll('.svg-btn-domains');
				for (var i = 0; i < adminsBtns.length; i++) {
					adminsBtns[i].addEventListener('click', function(e) {
						e.preventDefault();
						e.stopPropagation();
						var tooltip = document.getElementById('tooltip-step2');
						var unSortedadmins = chart.get(this.parentNode.getAttribute('data-n-id')).admins;
						var sortedAdmins = _.sortBy(unSortedadmins, 'firstName');
						var elements = sortedAdmins.map((v) => {
							return `${v.firstName} ${v.lastName}`;
						});

						ReactDOM.render(
							<ThemeProvider theme={theme}>
								<RemoveAdminsTooltip
									nodeId={this.parentNode.getAttribute('data-n-id')}
									elements={elements}
									nodes={nodes}
									setNodes={setNodes}
								/>
							</ThemeProvider>,
							document.querySelector('#custom-tooltip-step2')
						);
						tooltip.classList.add('visible');

						var btns = document.querySelectorAll('#closeTooltip-admins');
						for (var i = 0; i < btns.length; i++) {
							btns[i].addEventListener('click', function(e) {
								var tooltip = document.getElementById('tooltip-step2');
								tooltip.classList.remove('visible');
							});
						}
						return false;
					});
				}

				for (var i = 0; i < domainsBtns.length; i++) {
					domainsBtns[i].addEventListener('click', function(e) {
						e.preventDefault();
						e.stopPropagation();
						var tooltip = document.getElementById('tooltip-step2');

						ReactDOM.render(
							<ThemeProvider theme={theme}>
								<RemoveAdminsTooltip
									nodeId={this.parentNode.getAttribute('data-n-id')}
									elements={chart.get(this.parentNode.getAttribute('data-n-id')).domains}
									nodes={nodes}
									setNodes={setNodes}
								/>
							</ThemeProvider>,
							document.querySelector('#custom-tooltip-step2')
						);
						tooltip.classList.add('visible');

						var btns = document.querySelectorAll('#closeTooltip-admins');
						for (var i = 0; i < btns.length; i++) {
							btns[i].addEventListener('click', function(e) {
								var tooltip = document.getElementById('tooltip-step2');
								tooltip.classList.remove('visible');
							});
						}
						return false;
					});
				}
				var addBtns = document.querySelectorAll('.svg-btn-add');
				var editBtns = document.querySelectorAll('.svg-btn-edit');
				var removeBtns = document.querySelectorAll('.svg-btn-remove');
				for (var i = 0; i < addBtns.length; i++) {
					addBtns[i].addEventListener('click', function(e) {
						e.stopPropagation();
						e.preventDefault();
						if (addCalled.current === 0) {
							var nodeId = this.getAttribute('data-id');
							addCalled.current = 1;
							let node = {};
							node.id = chart.generateId();
							node.pid = nodeId;
							let newItemLevel = sender.nodes[nodeId].level + 1;
							let nodesAtCurrentLevel = getNodeCountAtGivenLevel(sender, newItemLevel);

							// If number of nodes at current level will be reaching to maxNodeAllowedAtAnyLevel after this element, in that case
							// remove the add menu option from parent items as we cannot allow user to add more items.
							if (nodesAtCurrentLevel === maxNodeAllowedAtAnyLevel - 1) {
								let parentId = Object.keys(sender.nodes).find(
									(key) => sender.nodes[key].level === sender.nodes[node.pid].level
								);
								let parentLevel = sender.nodes[parentId].level;
								let tagToBeApplied =
									parentLevel === 0
										? ['rootElement_maxNodeAddedAtNextLevel']
										: ['middleElement_maxNodeAddedAtNextLevel'];
								updateTagAtGivenLevel(sender, parentLevel, tagToBeApplied);
							}

							// Below condition should never match as user will not see add option after maxNodeAllowedAtAnyLevel
							if (nodesAtCurrentLevel === maxNodeAllowedAtAnyLevel) {
								return false;
							}

							// on last node, don't show add options as only supported level is parent, child, grandchild, great grandchild
							if (sender.nodes[node.pid].level === 2) {
								node.tags = ['lastNodeElements'];
							} else {
								node.tags = ['middleNodeElements'];
							}
							node.entityName = labels.enterEntityName;
							node.engagements = [];
							node.engagementLabel = labels.connectedToEngagements(node.engagements.length);
							node.accessGroups = [];
							node.admins = [];
							node.domains = [];
							node.adminsHeaderLabel = labels.adminsHeaderLabel;
							node.firstAdmin = labels.adminsNoneLabel;
							node.adminsMoreCountLabel = '';
							node.domainsHeaderLabel = labels.domainsHeaderLabel;
							node.firstDomain = labels.none;
							node.adminsMoreCountLabel = '';
							node.addBtn = i;
							setNodes([...nodes, node]);
							nodeStateUpdate(node.id);
							resetRef();
							return false;
						}
					});
				}

				for (var i = 0; i < editBtns.length; i++) {
					editBtns[i].addEventListener('click', function(e) {
						if (!showModal) {
							e.preventDefault();
							e.stopPropagation();
							var nodeId = this.getAttribute('data-id');
							var nodeElement = findElement(nodeId);
							nodeElement?.classList.add('active-node');
							let nodeDetails = props.nodes.filter((node) => node.id === nodeId);
							console.log(selectedNode);
							setSelectedNode(nodeDetails[0]);
							setShowModal(true);
						}
					});
				}
				for (var i = 0; i < removeBtns.length; i++) {
					removeBtns[i].addEventListener('click', function(e) {
						e.preventDefault();
						e.stopPropagation();
						var nodeId = this.getAttribute('data-id');
						// Get count of nodes for the level where node is removed.
						let levelOfRemovedItem = sender.nodes[nodeId].level;
						let nodesAtCurrentLevel = getNodeCountAtGivenLevel(sender, levelOfRemovedItem);
						// If after removal of this node, we will have less nodes then maxNodeAllowedAtAnyLevel
						// in this case Parent nodes should be allowed to add new node.
						if (nodesAtCurrentLevel === maxNodeAllowedAtAnyLevel) {
							let parentLevel = levelOfRemovedItem - 1;
							let tagToBeApplied = parentLevel === 0 ? [] : ['middleNodeElements'];
							updateTagAtGivenLevel(sender, parentLevel, tagToBeApplied);
						}
						removedNode(sender, nodeId);
						chart.removeNode(nodeId);
						//chart.removeNode(nodeId)
					});
				}
			});
			OrgChart.templates.entityTemplate = Object.assign({}, OrgChart.templates.ula);
			OrgChart.templates.ula.size = [250, 130];

			OrgChart.EDITFORM_CLOSE_BTN = `<div title=${labels.closeLabel} data-edit-from-close class="close-icon">x</div>`;

			OrgChart.templates.entityTemplate.field_0 =
				'<text data-width="230" data-text-overflow="ellipsis" style="font-size: 1rem; font-weight:400;" x="10" y="25" text-anchor="left" class="field_0">{val}</text>';
			OrgChart.templates.entityTemplate.field_1 =
				'<text data-width="100" data-text-overflow="ellipsis" style="font-size: 0.8571rem; font-weight:300;" x="10" y="50" text-anchor="left" class="field_1">{val}</text>';
			OrgChart.templates.entityTemplate.field_2 =
				'<text data-width="150" data-text-overflow="ellipsis" style="font-size: 0.8571rem; font-weight:400;" x="60" y="50" text-anchor="left" class="field_2">{val}</text>';
			OrgChart.templates.entityTemplate.field_3 =
				'<text width="50" text-overflow="ellipsis" style="font-size: 1.2rem;font-weight: 600; cursor: pointer;" x="180" y="50" text-anchor="right" class="svg-btn-admins field_3">{val}</text>';
			OrgChart.templates.entityTemplate.field_4 =
				'<text data-width="57" data-text-overflow="ellipsis" style="font-size: 0.8571rem; font-weight:300;" x="10" y="75" text-anchor="left" class="field_4">{val}</text>';
			OrgChart.templates.entityTemplate.field_5 =
				'<text data-width="93" data-text-overflow="ellipsis" style="font-size: 0.8571rem; font-weight:400;" x="67" y="75" text-anchor="left" class="field_5">{val}</text>';
			OrgChart.templates.entityTemplate.field_6 =
				'<text width="50" text-overflow="ellipsis" style="font-size: 1.2rem;font-weight: 600;cursor: pointer;" x="180" y="75" text-anchor="left" class="svg-btn-domains field_6">{val}</text>';

			OrgChart.templates.entityTemplate.field_7 = '{val}';

			chart.on('field', function(sender, args) {
				if (args.name === 'addBtn' || args.name === 'editBtn' || args.name === 'removeBtn') {
					args.value = args.data.id;
				}
			});

			chart.load(
				nodes.map((x) => {
					return {...x, escapedEntityName: _.escape(x.entityName), addBtn: x.id};
				})
			);
		}
	});

	const renderCollapseBtn = () => {
		const props = {
			svg: IconoirNavArrowUp,
			iconSize: 20,
			variant: 'text-alt',
			title: labels.collapseAll,
			label: labels.collapseAll,
			onClick: () => {
				handleCollapseClick();
			}
		};
		return <Button {...props} />;
	};

	const renderExpandBtn = () => {
		const props = {
			svg: IconoirNavArrowDown,
			iconSize: 20,
			variant: 'text-alt',
			title: labels.expandAll,
			label: labels.expandAll,
			onClick: () => {
				handleExpandClick();
			}
		};
		return <Button {...props} />;
	};

	return (
		<StyledOrgWrapper>
			<LevelLegends nodes={nodes} />
			<section className="expand-collapse">
				{renderExpandBtn()}
				{renderCollapseBtn()}
			</section>
			{showModal && (
				<EntityModal
					showModal={showModal}
					setShowModal={setShowModal}
					selectedNode={selectedNode}
					saveEntityDetails={saveEntityDetails}
					existingDomains={existingDomains}
				/>
			)}
			<section id="tree" className="step2-org-tree" ref={divRef}></section>
			<section id="tooltip-step2" class="tooltip-menu">
				<section id="custom-tooltip-step2" class="step2-tooltip tooltip-content"></section>
			</section>
		</StyledOrgWrapper>
	);
};

export default Step2OrgChart;

const StyledOrgWrapper = styled.section`
	position: relative;
	.bg-toolbar-container {
		left: 30px;
		top: 30px;
		width: 4rem;
		height: 7.5rem;
	}
	.legends-wrap {
		top: var(--px-54);
		left: var(--px-54);
		margin-left: var(--px-32);
	}
	.edit-tags {
		display: none;
	}
	.tooltip-menu {
		opacity: 1;
		background-color: rgb(255, 254, 255);
		box-shadow: rgb(220, 220, 220) 0px 1px 2px 0px;
		display: inline-block;
		z-index: 1000;
		position: fixed;
		text-align: left;
		user-select: none;
		width: 25rem;
		top: 38.5%;
		right: 2%;
	}
	.visible .tooltip .tooltip-content {
		opacity: 1;
		-webkit-transform: translate3d(0, 50%, 0) rotate3d(0, 0, 0, 0);
		transform: translate3d(0, 50%, 0) rotate3d(0, 0, 0, 0);
		pointer-events: auto;
	}
	.step2-tooltip {
		.eng-row {
			border-bottom: 0;
			padding-bottom: 0;
			&:last-child {
				padding-bottom: 1rem;
			}
		}
	}
	.tooltip-content {
		width: 100%;
		height: 100%;
		display: inline-block;
		z-index: 9999;
		border: solid 1px ${(props) => props.theme.color[`grey300`]};
		font-size: 1.3rem;
		background-color: ${(props) => props.theme.color[`white`]};
		box-shadow: 3px 6px 6px 0px ${(props) => props.theme.color[`grey300black`]};
	}
	.visible .tooltip {
		opacity: 1;
	}
	.tooltip-menu.visible {
		display: block;
	}
	.tooltip-menu {
		display: none;
	}
	.step2-org-tree {
		width: 100% !important;
		height: 750px;
		svg {
			background: ${(props) => props.theme.color[`white`]};
			rect {
				fill: ${(props) => props.theme.color[`white`]};
				cursor: default !important;
			}

			.field_0 {
				fill: ${(props) => props.theme.color[`black`]};
				font-family: var(--primary-font);
			}
			.field_1,
			.field_2 {
				fill: ${(props) => props.theme.color[`grey400`]};
				font-family: var(--primary-font);
			}
			.field_3 {
				fill: ${(props) => props.theme.color[`blue600yellow400`]};
				font-family: var(--primary-font);
			}
			.field_4,
			.field_5 {
				fill: ${(props) => props.theme.color[`grey400`]};
				font-family: var(--primary-font);
			}
			.field_6 {
				fill: ${(props) => props.theme.color[`blue600yellow400`]};
				font-family: var(--primary-font);
			}
		}

		.active-node text {
			fill: ${(props) => props.theme.color[`white`]};
		}

		.active-node rect {
			stroke: none;
		}

		.active-node[data-sl='0'] rect {
			fill: ${(props) => props.theme.color[`green400`]} !important;
		}
		.active-node[data-sl='1'] rect {
			fill: ${(props) => props.theme.color[`blue400`]} !important;
		}
		.active-node[data-sl='2'] rect {
			fill: ${(props) => props.theme.color[`orange500`]} !important;
		}
		.active-node[data-sl='3'] rect {
			fill: ${(props) => props.theme.color[`purple200`]} !important;
		}

		.active-node g circle {
			fill: ${(props) => props.theme.color[`white`]};
		}
	}

	.ellipsis {
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		display: inline-block;
	}

	.expand-collapse {
		display: flex;
		justify-content: flex-end;
		width: 99%;
		gap: 1rem;
		button {
			display: flex;
			align-items: center;
			max-width: 15rem;
			justify-content: flex-end;
			.motif-icon {
				width: 2.4rem;
				height: 2.4rem;
				svg {
					width: 2.4rem !important;
					height: 2.4rem !important;
				}
			}
			&:focus,
			&:hover {
				background: none;
			}
		}
		#collapse_btn {
			svg {
				transform: rotate(180deg);
			}
		}
		span {
			display: inline-block;
			color: ${(props) => props.theme.color[`blue600yellow400`]};
			font-weight: 400;
			width: calc(100% - 2.4rem);
		}
	}

	.eng-icon {
		fill: ${(props) => props.theme.color[`grey400`]};
		width: 3rem;
		height: 3rem;
		display: inline-block;
	}
`;

const StyledHelpBlock = styled.section`
	color: ${(props) => props.theme.color[`grey500`]};
	margin-top: 0.5rem;
	font-size: 1.3rem;
	display: flex;
	align-items: center;
	padding: 0 0.5rem;

	& svg {
		width: 1.6rem;
		height: 1.6rem;
		fill: ${(props) => props.theme.color[`red600`]};
		margin: 0 0.5rem 0 0;
		vertical-align: text-bottom;
	}

	& .error-text {
		color: ${(props) => props.theme.color[`red600`]};
	}
`;
